<template>
  <el-dialog
    custom-class="dialog-modal-song" title="EDIT SONG" :model-value="flagVisible" width="770px"
    :before-close="handleClose"
  >
    <div class="modal-create-song">
      <el-form ref="form" :model="song" size="small">
        <div class="create-info">
          <div class="info-title">
            <span>SONG INFO</span>
          </div>
          <div class="info-columns">
            <el-form-item>
              <el-input v-model="song.name" placeholder="Song Name [eg. “Various Podcast VO Reads” or “Bright Side of the Moon”"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="song.song_writer" placeholder="Artist Name [eg. The Beatles]"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button size="small" class="el-btn-blue" :loading="flagLoading.save" @click="handleSave">SAVE</el-button>
        <el-button size="small" @click="handleClose">CANCEL</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { reactive } from 'vue'
export default {
  props: {
    role: String,
    brandId: String,
    flagVisible: Boolean,
    actionItem: Object
  },
  emits: ['closeModal', 'reloadSongs'],
  data: function () {
    const flagLoading = reactive({
      save: false
    })
    return {
      song: {},
      flagLoading
    }
  },
  created: function () {
  },
  watch: {
    actionItem: {
      handler: function (val, oldVal) {
        if (val !== oldVal) this.song = { ...val }
      },
      deep: true
    }
  },
  methods: {
    handleClose: function () {
      this.$emit('closeModal')
    },
    handleSave: function () {
      this.updateSong()
    },
    updateSong: function () {
      this.flagLoading.save = true
      const url = `/api/v1/atk_player${this.role === 'admin' ? '/admin' : ''}/songs/${this.song._id}`
      const that = this
      const body = { ...this.song }
      if (this.role === 'admin') body.brand_id = this.brandId
      this.$service.put(url, body).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Update song success' })
          that.handleClose()
          setTimeout(function () {
            that.$emit('reloadSongs')
          }, 100)
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('updateSong', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.save = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.modal-create-song {
  color: black;
  .create-desc {
    .desc-sub-title {
      font-size: 16px;
      font-weight: bold;
    }
    .desc-sub-text {
      font-size: 16px;
      margin-top: 20px;
    }
  }
  .create-info {
    .info-title {
      font-size: 18px;
      font-weight: 300;
      margin-bottom: 20px;
    }
    .info-columns {
      margin-top: 10px;
    }
  }
}
</style>
